/**
 * Centralized Map of all running conductor FTs and AB tests
 * scope to use -- viewer-apps-9a5d83fd-8570-482e-81ab-cfa88942ee60
 * use `Meta Site id` as a seed value
 */
export const EXPERIMENTS = {
  USE_DISCOUNT_ON_ORDERING_PAGE: 'useDiscountOnOrderingPage',
  ALLOW_MENU_ITEM_SEO_RENDER_TIME: 'allowMenuItemSeoRenderTimeForOLO',
  ADD_WARMUP_DATA_TO_ONLINE_ORDERS_WIDGET: 'addWarmupDataToOnlineOrdersWidget',
  CHECKOUT_DELIVERY_OPTIONS:
    'restaurantsShouldOmitDeliveryTimeSlotForScheduledDeliveryOrders',
  ITEM_IMAGE_LAYOUT_SETTINGS: 'specs.restaurants.olo.installOoiComponents',
};
